import { useHandleCartAuth } from '~/features/store';

export default defineNuxtPlugin(() => {
  useHandleCartAuth();
});
